export const SITE_URL = "https://ledgerowl.com.au";
